




/* eslint-disable no-sequences */
/* eslint-disable no-unused-vars */
/* eslint-disable no-param-reassign */
/* eslint-disable no-unused-expressions */

import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { defaultReject, defaultState } from "../../../constants";
import { fetchData } from "../../../helpers";
// customerRegister
// CUSTOMERREGISTER
const CONNECTIONSGETALL= createAsyncThunk(
  "ConnectionsGetAll/ConnectionsGetAll",
  // eslint-disable-next-line default-param-last
  async (
    // eslint-disable-next-line default-param-last
    payload = {},
    { rejectWithValue }
  ) => {
    try {
      const data = await fetchData(
        payload?.data,
        payload?.method,
        payload?.apiName
      );
      return {
        ...defaultState.List,
        message: data?.data.Message,
        data: data?.data?.data,
      };
    } catch (error) {
      return rejectWithValue({
        ...defaultReject.List,
        message: error.message,
      });
    }
  }
);

// PublishPostSlice
const ConnectionsGetAllSlice = createSlice({
  name: "ConnectionsGetAllSlice",
  initialState: {
    ConnectionsGetAll: {
      ...defaultState.List,
      loading: false, 
      error: false, 
    },
  },
  reducers: {
    setInitialStateOfConnectionsGetAll: (state) => {
        state.ConnectionsGetAll.loading = false
        state.ConnectionsGetAll.error = false
        state.ConnectionsGetAll.data = []
        state.ConnectionsGetAll.message = ''
      }
  },
  extraReducers: (builder) => {
    builder.addCase(CONNECTIONSGETALL.fulfilled, (state, action) => {
      state.ConnectionsGetAll = {
        ...state.ConnectionsGetAll,
        loading: false,
        error: false,
        ...action.payload,
      };
    });
    builder.addCase(CONNECTIONSGETALL.pending, (state, action) => {
      state.ConnectionsGetAll = {
        ...state.ConnectionsGetAll,
        loading: true,
        error: false,
        ...action.payload,
      };
    });
    builder.addCase(CONNECTIONSGETALL.rejected, (state, action) => {
      state.ConnectionsGetAll = {
        ...state.ConnectionsGetAll,
        loading: false,
        error: true,
        ...action.payload,
      };
    });
  },
});

const ConnectionsGetAllAction = {
    CONNECTIONSGETALL,
};

export { ConnectionsGetAllAction };
export default ConnectionsGetAllSlice.reducer;
export const {setInitialStateOfConnectionsGetAll} = ConnectionsGetAllSlice.actions
